<ng-container *ngIf="products$ | async; let products; else: noProducts">
	<div fxFlexFill fxLayout="row wrap" fxLayoutGap="10px grid" *ngIf="products.length">
		<div
			class="product-wrapper"
			fxFlex="33"
			fxFlex.lt-md="50"
			*ngFor="let product of products"
			[ngClass]="{ 'is-not-public': !product.is_published }"
		>
			<a [routerLink]="['/product', product.id, product.slug]" (click)="productClick(product.id)">
				<div class="product-img-wrapper" fxLayoutAlign="center center">
					<div class="square-image-container">
						<div class="square-image-inner image-wrapper">
							<img
								width="270"
								gFallbackProductImage
								class="square-image-centered"
								*ngIf="product?.images?.master"
								[src]="product?.images?.master?.fitIn_270x270"
								[alt]="product?.locale.product_name | getText"
								loading="lazy"
							/>
						</div>
					</div>
				</div>
				<div class="product-info-wrapper">
					<div class="product-name" [attr.title]="product?.locale.product_name | getText">{{
						product?.locale.product_name | getText
					}}</div>
					<div class="product-subtext">
						{{ product?.locale.product_name_sub_text | getText }}
					</div>
				</div>
			</a>
		</div>
	</div>
</ng-container>
<ng-template #noProducts>
	<div i18n>No products.</div>
</ng-template>
